<div class="container-fluid" style="text-align: center; padding-top: 1%">
  @if (txnStatus) {
    @if (txnStatus && txnStatus.status == 'completed') {
      <img src="../../../../../assets/rexpay/Confirmed.svg" />
      <br /><br />
      <h3>Payment already completed</h3>
      <p>You have completed the payment for this transaction</p>
    }
    @if (txnStatus.status == 'success') {
      <img src="../../../../../assets/rexpay/Confirmed.svg" />
      <br /><br />
      <h3>Payment Successful</h3>
      <p>
        You have made a payment of
        <b>{{ txnStatus.currency }} {{ txnStatus.amount }} </b> to
        <b>{{ customerName ? customerName : storeName }}</b> We have sent a
        receipt to your email and
        {{
        isCallBackUrl
        ? "we are redirecting to your url"
        : "we will inform your merchant"
        }}
      </p>
      @if (isCallBackUrl) {
        <span
          class="success_footer"
          (click)="redirectUser()"
        ></span>
      }
      <div class="success-footer">
        <!-- <span class="border-pipe"><a class="btn-link">Print Receipt</a></span> -->
        <span class="ml-1">
          <a
            [style.color]="
              whiteLabelInfo ? whiteLabelInfo.brandColor : '#ed1c25'
            "
            class="rate-link"
            routerLink="/rating"
            >
            Rate Your Experience
          </a>
        </span>
      </div>
    }
    @if (txnStatus.status != 'success' && txnStatus.status != 'completed') {
      <img src="../../../../../assets/rexpay/Failed.svg" />
      <br /><br />
      <h3 class="heading__3">Payment Failed</h3>
      <p>Your Transaction failed for some certain reasons. please try again</p>
      <!-- <button class="button">Retry Payment</button> -->
    }
    <div
      class="footer"
      style="margin-top: 30%; text-align: center; font-size: 12px"
      >
      <app-footer [whiteLabelInfo]="whiteLabelInfo"></app-footer>
    </div>
  }
</div>
